import { Injectable } from '@angular/core';

import { HighlightName, ITourHighlightDirective } from './interface';

@Injectable({ providedIn: 'root' })
export class TourHighlightService {
  private activeInstances: ITourHighlightDirective[] = [];
  private visibleInstanceName: HighlightName;

  public pushActiveInstance(componentInstance: ITourHighlightDirective): void {
    this.activeInstances.push(componentInstance);
  }

  public show(name: HighlightName): void {
    this.hideActiveInstances();
    this.showArrowByName(name);
  }

  public hideActiveInstances(): void {
    this.activeInstances.forEach(instance => {
      if (instance.name === this.visibleInstanceName) {
        instance.hide();
      }
    });
  }

  private showArrowByName(name: HighlightName): void {
    this.activeInstances.forEach(instance => {
      if (instance.name === name) {
        instance.show();
        this.visibleInstanceName = name;
      }
    });
  }
}
